/*根据需求引用*/
// import cesium_tool from "./cesium_tool/cesium_tool"/*引入三维球函数工具库*/
// import api_tool from "./api_tool/api_tool_main"/*通用的 获取接口的数据并做通用处理的api工具*/

import map_tool from "./sys_tool/map_tool"/*地图工具库*/
import geojson_tool from "./sys_tool/geojson_tool"/*geojson解析库*/
import common_tool from "./sys_tool/common_tool"/*其他常用函数工具库*/
import tile_util from "./sys_tool/TileUtil"/*TileUtil工具库*/
import calculate_tool from "./sys_tool/calculate_tool"/*引入地图计算函数工具库*/
import common_store from "./sys_tool/common_store"/*全局变量存储*/
import api_dictionaries_data from "./sys_tool/api_dictionaries_data"/*获取字典表工具*/
import drawmapGlobal from "./map_global" /*制图工具用到的全局变量 */
import api_recordLog from './sys_tool/api_recordLog_sz_by_data'/*用户记录功能 无用户管理请注释掉*/
import api_xzq_data from './sys_tool/api_xzq_data'/*用户权限使用 无用户管理请注释掉*/
import drillDown_tool from "../drillDown/drilldown_tool"/*下钻工具*/
import sys_marker_tool from "./sys_tool/sys_makrer_tool"
import { saveAs } from 'file-saver';
import './sys_tool/drag'
import get_administrator_dictionaries_data from './sys_tool/get_administrator_dictionaries_data'
export default {
  map_tool,/*地图操作工具库*/
  sys_marker_tool,/*marker管理工具*/
  geojson_tool,/*geojson解析工具*/
  common_tool,/*通用函数库*/
  tile_util,/*tile_util工具库*/
  calculate_tool,/*计算函数库*/
  common_store,/*全局变量存储*/
  drillDown_tool,/*下钻工具*/
  api_dictionaries_data,/*获取字典表工具*/

  api_recordLog,
  api_xzq_data,
  get_administrator_dictionaries_data,/*最新字典工具*/

  /*根据需求引用*/
  /*cesium_tool,*/
  /*api_tool,*/


  downloadBlobFile(file, name, extension){
    let timeStr = new Date().toJSON();
    let fileName = timeStr.substring(0,10).replace(/-/g,'') + "_" +
                    timeStr.substring(11,19).replace(/:/g,'') +"_" +
                    name + "." + extension;
    let blob;
    if(extension==="xls"){
      blob = new Blob([file],{type: "application/vnd.ms-excel;charset=utf-8"})
    }else if(extension==="zip"){
      blob = new Blob([file],{type: "application/zip;charset=utf-8"})
    }else if(extension==="doc" ){
      blob = new Blob([file],{type: "application/msword;charset=utf-8"})
    }
    saveAs(blob,fileName);
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/Global.js